import { byMedia } from '../helpers/media';
import { getPx } from '../helpers/common';
export var translateY = byMedia(function (value) {
  return "transform: translateY(" + getPx(value) + ");";
});